import { IPaginationResponse } from '../../../common';
import {
  IOffStreetOrderResponse,
  IOrderLookupsResponse,
  IOrderPaymentRequestResponse,
  IOrderResponse,
  ISubjectServiceOrderItemResponse,
  ISubscriptionOrderDetailsResponse,
  IOnStreetOrderDetailsResponse,
} from '../dtos';

const orderResponse: IOrderResponse = {
  id: '550e8400-e29b-41d4-a716-446655440000',
  createdOnUtc: '2025-02-25T10:00:00Z',
  modifiedOnUtc: '2025-02-25T11:00:00Z',
  createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
  modifiedById: 'f1e2d3c4-b5a6-47c8-9d0e-11a22b3c4d5e',
  client: {
    id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
    englishName: 'Provider One',
    arabicName: 'العميل الاول'
  },
  project: {
    id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
    englishName: 'Main Center',
    arabicName: 'المركز الرئيسي'
  },
  customer: {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    englishName: 'John Doe',
    type: 'Customer',
    subscriptionType: 'B2C'
  },
  totalPrice: {
    amount: 250.75,
    currency: 'USD'
  },
  paymentType: 'Cash',
  type: 'Subscription',
  orderDocuments: [
    {
      id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
      document: {
        id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
        englishName: 'Medicine A',
        arabicName: 'Test',
      },
      attachment: {
        id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
        name: 'test',
        size: 20
      }
    }
  ],
  orderItems: [
    {
      id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
      type: 'Product',
      englishName: 'Medicine A',
      arabicName: 'Test',
      itemDetailsId: 'd9f8d49a-1c2b-49fc-8b5f-8aeb0e8c5d2d',
      unitOfMeasurement: 'Box',
      quantity: 2,
      descriptionEn: 'test',
      descriptionAr: 'test',
      unitPrice: {
        amount: 50.37,
        currency: 'USD'
      },
      totalPrice: {
        amount: 50.37,
        currency: 'USD'
      }
    },
    {
      id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
      type: 'Product',
      englishName: 'Medicine A',
      arabicName: 'Test',
      itemDetailsId: 'd9f8d49a-1c2b-49fc-8b5f-8aeb0e8c5d2d',
      unitOfMeasurement: 'Box',
      quantity: 2,
      descriptionEn: 'test',
      descriptionAr: 'test',
      unitPrice: {
        amount: 50.37,
        currency: 'USD'
      },
      totalPrice: {
        amount: 50.37,
        currency: 'USD'
      }
    }
  ],
  status: '',
  paymentId: '550e8400-e29b-41d4-a716-446655440000'
};

const createOrderResponse: IOrderResponse = {
  id: '550e8400-e29b-41d4-a716-446655440000',
  createdOnUtc: '2025-02-25T10:00:00Z',
  modifiedOnUtc: '2025-02-25T11:00:00Z',
  createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
  modifiedById: 'f1e2d3c4-b5a6-47c8-9d0e-11a22b3c4d5e',
  client: {
    id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
    englishName: 'Provider One',
    arabicName: 'العميل الاول'
  },
  project: {
    id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
    englishName: 'Main Center',
    arabicName: 'المركز الرئيسي'
  },
  customer: {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    englishName: 'John Doe',
    type: 'Customer',
    subscriptionType: 'B2C'
  },
  totalPrice: {
    amount: 250.75,
    currency: 'USD'
  },
  paymentType: 'Cash',
  type: 'Subscription',
  orderItems: [
    {
      id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
      type: 'Product',
      englishName: 'Medicine A',
      arabicName: 'Test',
      itemDetailsId: 'd9f8d49a-1c2b-49fc-8b5f-8aeb0e8c5d2d',
      unitOfMeasurement: 'Box',
      quantity: 2,
      descriptionEn: 'test',
      descriptionAr: 'test',
      unitPrice: {
        amount: 50.37,
        currency: 'USD'
      },
      totalPrice: {
        amount: 50.37,
        currency: 'USD'
      }
    },
    {
      id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
      type: 'Product',
      englishName: 'Medicine A',
      arabicName: 'Test',
      itemDetailsId: 'd9f8d49a-1c2b-49fc-8b5f-8aeb0e8c5d2d',
      unitOfMeasurement: 'Box',
      quantity: 2,
      descriptionEn: 'test',
      descriptionAr: 'test',
      unitPrice: {
        amount: 50.37,
        currency: 'USD'
      },
      totalPrice: {
        amount: 50.37,
        currency: 'USD'
      }
    }
  ],
  status: 'Draft',
  paymentId: '550e8400-e29b-41d4-a716-446655440000'
};

const createOrderPaymentRequestResponse: IOrderPaymentRequestResponse = {
  order: {
    id: '550e8400-e29b-41d4-a716-446655440000',
    createdOnUtc: '2025-02-25T10:00:00Z',
    modifiedOnUtc: '2025-02-25T11:00:00Z',
    createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
    modifiedById: 'f1e2d3c4-b5a6-47c8-9d0e-11a22b3c4d5e',
    client: {
      id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
      englishName: 'Provider One',
      arabicName: 'العميل الاول'
    },
    project: {
      id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
      englishName: 'Main Center',
      arabicName: 'المركز الرئيسي'
    },
    customer: {
      id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      englishName: 'John Doe',
      type: 'Customer',
      subscriptionType: 'B2C'
    },
    totalPrice: {
      amount: 250.75,
      currency: 'USD'
    },
    paymentType: 'Cash',
    type: 'Subscription',
    orderItems: [
      {
        id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
        type: 'Product',
        englishName: 'Medicine A',
        arabicName: 'Test',
        itemDetailsId: 'd9f8d49a-1c2b-49fc-8b5f-8aeb0e8c5d2d',
        unitOfMeasurement: 'Box',
        quantity: 2,
        descriptionEn: 'test',
        descriptionAr: 'test',
        unitPrice: {
          amount: 50.37,
          currency: 'USD'
        },
        totalPrice: {
          amount: 50.37,
          currency: 'USD'
        }
      },
      {
        id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
        type: 'Product',
        englishName: 'Medicine A',
        arabicName: 'Test',
        itemDetailsId: 'd9f8d49a-1c2b-49fc-8b5f-8aeb0e8c5d2d',
        unitOfMeasurement: 'Box',
        quantity: 2,
        descriptionEn: 'test',
        descriptionAr: 'test',
        unitPrice: {
          amount: 50.37,
          currency: 'USD'
        },
        totalPrice: {
          amount: 50.37,
          currency: 'USD'
        }
      }
    ],
    status: 'Draft',
    paymentId: '550e8400-e29b-41d4-a716-446655440000'
  },
  paymentRequest: {
    id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
    paymentId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
    paymentConfigurationId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
    paymentProviderType: 'hyperpay',
    paymentRequestId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
    paymentUrl: 'url',
    integrity: 'integrity url',
    modifiedOnUtc: '2025-02-18T20:11:49.4609172',
    createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
    modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
    createdOnUtc: '2025-02-18T20:11:49.4609054'
  }
};

const ordersResponse: IPaginationResponse<IOrderResponse> = {
  items: [
    {
      id: '550e8400-e29b-41d4-a716-446655440000',
      createdOnUtc: '2025-02-25T10:00:00Z',
      modifiedOnUtc: '2025-02-25T11:00:00Z',
      createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
      modifiedById: 'f1e2d3c4-b5a6-47c8-9d0e-11a22b3c4d5e',
      client: {
        id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
        englishName: 'Provider One',
        arabicName: 'العميل الاول'
      },
      project: {
        id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
        englishName: 'Main Center',
        arabicName: 'المركز الرئيسي'
      },
      customer: {
        id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        englishName: 'John Doe',
        type: 'Customer',
        subscriptionType: 'B2C'
      },
      totalPrice: {
        amount: 250.75,
        currency: 'USD'
      },
      paymentType: 'Cash',
      type: 'Subscription',
      orderItems: [
        {
          id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
          type: 'Product',
          englishName: 'Medicine A',
          arabicName: 'Test',
          itemDetailsId: 'd9f8d49a-1c2b-49fc-8b5f-8aeb0e8c5d2d',
          unitOfMeasurement: 'Box',
          quantity: 2,
          descriptionEn: 'test',
          descriptionAr: 'test',
          unitPrice: {
            amount: 50.37,
            currency: 'USD'
          },
          totalPrice: {
            amount: 50.37,
            currency: 'USD'
          },
        },
        {
          id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
          type: 'Product',
          englishName: 'Medicine A',
          arabicName: 'Test',
          itemDetailsId: 'd9f8d49a-1c2b-49fc-8b5f-8aeb0e8c5d2d',
          unitOfMeasurement: 'Box',
          quantity: 2,
          descriptionEn: 'test',
          descriptionAr: 'test',
          unitPrice: {
            amount: 50.37,
            currency: 'USD'
          },
          totalPrice: {
            amount: 50.37,
            currency: 'USD'
          }
        }
      ],
      status: 'Draft',
      paymentId: '550e8400-e29b-41d4-a716-446655440000'
    },
    {
      id: '550e8400-e29b-41d4-a716-446655440000',
      createdOnUtc: '2025-02-25T10:00:00Z',
      modifiedOnUtc: '2025-02-25T11:00:00Z',
      createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
      modifiedById: 'f1e2d3c4-b5a6-47c8-9d0e-11a22b3c4d5e',
      client: {
        id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
        englishName: 'Provider One',
        arabicName: 'العميل الاول'
      },
      project: {
        id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
        englishName: 'Main Center',
        arabicName: 'المركز الرئيسي'
      },
      customer: {
        id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        englishName: 'John Doe',
        type: 'Customer',
        subscriptionType: 'B2C'
      },
      totalPrice: {
        amount: 250.75,
        currency: 'USD'
      },
      paymentType: 'Cash',
      type: 'Subscription',
      orderItems: [
        {
          id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
          type: 'Product',
          englishName: 'Medicine A',
          arabicName: 'Test',
          itemDetailsId: 'd9f8d49a-1c2b-49fc-8b5f-8aeb0e8c5d2d',
          unitOfMeasurement: 'Box',
          quantity: 2,
          descriptionEn: 'test',
          descriptionAr: 'test',
          unitPrice: {
            amount: 50.37,
            currency: 'USD'
          },
          totalPrice: {
            amount: 50.37,
            currency: 'USD'
          }
        },
        {
          id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
          type: 'Product',
          englishName: 'Medicine A',
          arabicName: 'Test',
          itemDetailsId: 'd9f8d49a-1c2b-49fc-8b5f-8aeb0e8c5d2d',
          unitOfMeasurement: 'Box',
          quantity: 2,
          descriptionEn: 'test',
          descriptionAr: 'test',
          unitPrice: {
            amount: 50.37,
            currency: 'USD'
          },
          totalPrice: {
            amount: 50.37,
            currency: 'USD'
          }
        }
      ],
      status: 'Draft',
      paymentId: '550e8400-e29b-41d4-a716-446655440000'
    }
  ],
  paginationMetadata: {
    totalItemCount: 2,
    numberOfPages: 1,
    pageSize: 2,
    order: 'Ascending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

const offStreetOrdersResponse: IPaginationResponse<IOffStreetOrderResponse> = {
  items: [
    {
      id: '550e8400-e29b-41d4-a716-446655440000',
      createdOnUtc: '2025-02-25T10:00:00Z',
      modifiedOnUtc: '2025-02-25T11:00:00Z',
      createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
      modifiedById: 'f1e2d3c4-b5a6-47c8-9d0e-11a22b3c4d5e',
      client: {
        id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
        englishName: 'Provider One',
        arabicName: 'العميل الاول'
      },
      project: {
        id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
        englishName: 'Main Center',
        arabicName: 'المركز الرئيسي'
      },
      customer: {
        id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        englishName: 'John Doe',
        type: 'Customer',
        subscriptionType: 'B2C'
      },
      totalPrice: {
        amount: 250.75,
        currency: 'USD'
      },
      paymentType: 'Cash',
      type: 'Subscription',
      orderItems: [
        {
          id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
          type: 'Product',
          englishName: 'Medicine A',
          arabicName: 'Test',
          itemDetailsId: 'd9f8d49a-1c2b-49fc-8b5f-8aeb0e8c5d2d',
          unitOfMeasurement: 'Box',
          quantity: 2,
          descriptionEn: 'test',
          descriptionAr: 'test',
          unitPrice: {
            amount: 50.37,
            currency: 'USD'
          },
          totalPrice: {
            amount: 50.37,
            currency: 'USD'
          },
        },
        {
          id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
          type: 'Product',
          englishName: 'Medicine A',
          arabicName: 'Test',
          itemDetailsId: 'd9f8d49a-1c2b-49fc-8b5f-8aeb0e8c5d2d',
          unitOfMeasurement: 'Box',
          quantity: 2,
          descriptionEn: 'test',
          descriptionAr: 'test',
          unitPrice: {
            amount: 50.37,
            currency: 'USD'
          },
          totalPrice: {
            amount: 50.37,
            currency: 'USD'
          }
        }
      ],
      status: 'Draft',
      paymentId: '550e8400-e29b-41d4-a716-446655440000',
      code: '1234567890',
      startTime: '2025-02-25T10:00:00Z',
      endTime: '2025-02-25T11:00:00Z'
    },
    {
      id: '550e8400-e29b-41d4-a716-446655440000',
      createdOnUtc: '2025-02-25T10:00:00Z',
      modifiedOnUtc: '2025-02-25T11:00:00Z',
      createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
      modifiedById: 'f1e2d3c4-b5a6-47c8-9d0e-11a22b3c4d5e',
      client: {
        id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
        englishName: 'Provider One',
        arabicName: 'العميل الاول'
      },
      project: {
        id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
        englishName: 'Main Center',
        arabicName: 'المركز الرئيسي'
      },
      customer: {
        id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        englishName: 'John Doe',
        type: 'Customer',
        subscriptionType: 'B2C'
      },
      totalPrice: {
        amount: 250.75,
        currency: 'USD'
      },
      paymentType: 'Cash',
      type: 'Subscription',
      orderItems: [
        {
          id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
          type: 'Product',
          englishName: 'Medicine A',
          arabicName: 'Test',
          itemDetailsId: 'd9f8d49a-1c2b-49fc-8b5f-8aeb0e8c5d2d',
          unitOfMeasurement: 'Box',
          quantity: 2,
          descriptionEn: 'test',
          descriptionAr: 'test',
          unitPrice: {
            amount: 50.37,
            currency: 'USD'
          },
          totalPrice: {
            amount: 50.37,
            currency: 'USD'
          }
        },
        {
          id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
          type: 'Product',
          englishName: 'Medicine A',
          arabicName: 'Test',
          itemDetailsId: 'd9f8d49a-1c2b-49fc-8b5f-8aeb0e8c5d2d',
          unitOfMeasurement: 'Box',
          quantity: 2,
          descriptionEn: 'test',
          descriptionAr: 'test',
          unitPrice: {
            amount: 50.37,
            currency: 'USD'
          },
          totalPrice: {
            amount: 50.37,
            currency: 'USD'
          }
        }
      ],
      status: 'Draft',
      paymentId: '550e8400-e29b-41d4-a716-446655440000',
      code: '1234567890',
      startTime: '2025-02-25T10:00:00Z',
      endTime: '2025-02-25T11:00:00Z'
    }
  ],
  paginationMetadata: {
    totalItemCount: 2,
    numberOfPages: 1,
    pageSize: 2,
    order: 'Ascending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

const offStreetOrderResponse: IOffStreetOrderResponse = {
  id: '550e8400-e29b-41d4-a716-446655440000',
  createdOnUtc: '2025-02-25T10:00:00Z',
  modifiedOnUtc: '2025-02-25T11:00:00Z',
  createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
  modifiedById: 'f1e2d3c4-b5a6-47c8-9d0e-11a22b3c4d5e',
  code: '1234567890',
  startTime: '2025-02-25T10:00:00Z',
  endTime: '2025-02-25T11:00:00Z',
  orderItems: [
    {
      id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
      type: 'Product',
      englishName: 'Medicine A',
      arabicName: 'Test',
      itemDetailsId: 'd9f8d49a-1c2b-49fc-8b5f-8aeb0e8c5d2d',
      unitOfMeasurement: 'Box',
      quantity: 2,
      unitPrice: {
        amount: 50.37,
        currency: 'USD'
      },
      totalPrice: {
        amount: 50.37,
        currency: 'USD'
      },
      descriptionEn: 'test',
      descriptionAr: 'test'
    }
  ],
  paymentId: '550e8400-e29b-41d4-a716-446655440000',
  client: {
    id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
    englishName: 'Provider One',
    arabicName: 'العميل الاول'
  },
  project: {
    id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
    englishName: 'Main Center',
    arabicName: 'المركز الرئيسي'
  },
  customer: {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    englishName: 'John Doe',
    type: 'Customer',
    subscriptionType: 'B2C'
  },
  totalPrice: {
    amount: 250.75,
    currency: 'USD'
  },
  paymentType: 'Cash',
  type: 'Subscription',
  status: 'Draft'
}

const subjectServiceOrderItemssResponse: IPaginationResponse<ISubjectServiceOrderItemResponse> = {
  items: [
    {
      serviceOrderItems: [
        {
          centerServiceId: "c7b396d7-9445-4e24-939e-da41bcd6f4aa",
          workerId: "9a66be0d-d701-446d-9b8d-9782b8460071",
          englishName: "qwqw",
          arabicName: 'Test',
          type: "Service",
          descriptionEn: 'test',
          descriptionAr: 'test',
          unitPrice: {
            amount: 50,
            currency: "EGP"
          },
          totalPrice: {
            amount: 50,
            currency: "EGP"
          },
          quantity: 1,
          unitOfMeasurement: "Fixed",
          createdOnUtc: "2025-03-26T07:19:51.5451563",
          modifiedOnUtc: "2025-03-26T07:19:51.5460561",
          createdById: "c8abfc2b-7ee3-460d-a71d-64ccedc07ba1",
          modifiedById: "c8abfc2b-7ee3-460d-a71d-64ccedc07ba1",
          id: "0a7c43e4-3138-41de-a0cf-1437c286acb7"
        },
      ],
      "englishName": "Vehicle",
      "id": "c3a2dd9e-9543-482e-8bb5-bc63e37616f9"
    },
    {
      serviceOrderItems: [
        {
          centerServiceId: "c7b396d7-9445-4e24-939e-da41bcd6f4aa",
          workerId: "9a66be0d-d701-446d-9b8d-9782b8460071",
          englishName: "test",
          arabicName: 'Test',
          type: "Service",
          descriptionEn: 'test',
          descriptionAr: 'test',
          unitPrice: {
            amount: 100,
            currency: "EGP"
          },
          totalPrice: {
            amount: 100,
            currency: "EGP"
          },
          quantity: 1,
          unitOfMeasurement: "Fixed",
          createdOnUtc: "2025-03-26T07:19:51.5451563",
          modifiedOnUtc: "2025-03-26T07:19:51.5460561",
          createdById: "c8abfc2b-7ee3-460d-a71d-64ccedc07ba1",
          modifiedById: "c8abfc2b-7ee3-460d-a71d-64ccedc07ba1",
          id: "0a7c43e4-3138-41de-a0cf-1437c286acb7"
        },
      ],
      "englishName": "Vehicle",
      "id": "c3a2dd9e-9543-482e-8bb5-bc63e37616f4"
    },
  ],
  paginationMetadata: {
    totalItemCount: 2,
    numberOfPages: 1,
    pageSize: 2,
    order: 'Ascending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
}

const lookups: IOrderLookupsResponse = {
  statuses: [
    {
      englishName: 'Draft',
      arabicName: 'مسودة',
      id: 'Cash'
    },
    {
      englishName: 'Submitted',
      arabicName: 'تم التقديم',
      id: 'Submitted'
    }
  ],
  paymentTypes: [
    {
      englishName: 'Cash',
      arabicName: 'نقدي',
      id: 'Cash'
    },
    {
      englishName: 'Visa',
      arabicName: 'فيزا',
      id: 'Visa'
    }
  ]
}


const subscriptionOrderDetailsResponse: ISubscriptionOrderDetailsResponse = {
  id: '550e8400-e29b-41d4-a716-446655440000',
  autoIncrementalId: 1001,
  createdOnUtc: '2025-02-25T10:00:00Z',
  modifiedOnUtc: '2025-02-25T11:00:00Z',
  createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
  modifiedById: 'f1e2d3c4-b5a6-47c8-9d0e-11a22b3c4d5e',
  orderId: '550e8400-e29b-41d4-a716-446655440000',
  orderStatus: 'Fulfilled',
  subscriptionStatus: 'Active',
  startDate: '2025-02-25T00:00:00Z',
  endDate: '2025-03-25T00:00:00Z',
  remainingDays: 25,
  paymentType: 'Online',
  client: {
    id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
    englishName: 'Makani Provider',
    arabicName: 'مزود مكاني',
    vatTaxAmount: 15
  },
  project: {
    id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
    englishName: 'Main Project',
    arabicName: 'المشروع الرئيسي'
  },
  customer: {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    englishName: 'John Doe',
    type: 'Customer',
    subscriptionType: 'B2C'
  },
  package: {
    id: 'c1b2a3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5d',
    englishName: 'Standard Monthly',
    arabicName: 'الباقة الشهرية القياسية',
    code: 'PKG-001',
    dayCount: 30,
    type: 'Monthly',
    theme: 'Blue',
    price: { amount: 300, currency: 'SAR' },
    locationCount: 1,
    displayOrder: 1,
    allowedForEndUsers: true,
    parkingAreas: [],
    weekDays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'],
    isApprovalRequired: false
  },
  vehicles: [],
  pricing: {
    subtotal: { amount: 300, currency: 'SAR' },
    vat: {
      vatAmount: { amount: 45, currency: 'SAR' },
      vatPercentage: 15
    },
    total: { amount: 345, currency: 'SAR' }
  }
};

const onStreetOrderDetailsResponse: IOnStreetOrderDetailsResponse = {
  id: '660e8400-e29b-41d4-a716-446655440001',
  autoIncrementalId: 1002,
  createdOnUtc: '2025-02-25T10:00:00Z',
  modifiedOnUtc: '2025-02-25T11:00:00Z',
  orderId: '660e8400-e29b-41d4-a716-446655440001',
  orderStatus: 'Fulfilled',
  reservationStatus: 'Active',
  startTime: '2025-02-25T10:00:00Z',
  endTime: '2025-02-25T12:00:00Z',
  totalHours: 2,
  remainingHours: 1,
  supportsOnlinePayment: true,
  vehicleRelationConfirmationStatus: 'Confirmed',
  paymentType: 'Online',
  source: 'Makani',
  client: {
    id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
    englishName: 'Makani Provider',
    arabicName: 'مزود مكاني'
  },
  project: {
    id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
    englishName: 'Main Project',
    arabicName: 'المشروع الرئيسي'
  },
  parkingArea: {
    id: 'e1b2c3d4-a5f6-4b7c-8d9e-0f1a2b3c4d5e',
    englishName: 'Al-Olaya Street Area',
    arabicName: 'منطقة شارع العليا'
  },
  customer: {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    englishName: 'John Doe',
    type: 'Customer',
    subscriptionType: 'B2C'
  },
  servicePrice: {
    id: 'b1c2d3e4-f5a6-4b7c-8d9e-0a1b2c3d4e5f',
    englishName: 'Hourly Standard',
    arabicName: 'سعر الساعة القياسي',
    hourRate: { amount: 10, currency: 'SAR' },
    vatPercentage: 15
  },
  pricing: {
    subtotal: { amount: 20, currency: 'SAR' },
    vat: {
      vatAmount: { amount: 3, currency: 'SAR' },
      vatPercentage: 15
    },
    total: { amount: 23, currency: 'SAR' }
  },
  invoices: []
};

export const ordersData = {
  ordersResponse,
  createOrderResponse,
  orderResponse,
  subjectServiceOrderItemssResponse,
  lookups,
  createOrderPaymentRequestResponse,
  offStreetOrdersResponse,
  offStreetOrderResponse,
  subscriptionOrderDetailsResponse,
  onStreetOrderDetailsResponse,
};
